'use client'
import { GrandSection, HTMLArticle } from 'ui'
import type { WidgetBlog } from 'ecosystem'
import type { FC } from 'react'

interface IBlogContentProps {
  blogPost: WidgetBlog
}

const BlogContent: FC<IBlogContentProps> = ({ blogPost }) => {
  return (
    <GrandSection as="article" sectionId="content" className="blog-content">
      <HTMLArticle content={blogPost.content} />
    </GrandSection>
  )
}

export default BlogContent
